export const images = [
  {
    src: './Website/Photography/Home/malaysia.jpg',
    details: 'The iconic Petronas Towers in Kuala Lumpur.',
  },
  {
    src: './Website/Photography/Home/bosnia.jpg',
    details: 'A beautiful view of the old bridge in Mostar.',
  },
  {
    src: './Website/Photography/Home/singapore.jpg',
    details: 'Marina Bay Sands and the city skyline.',
  },
  {
    src: './Website/Photography/Home/qatar.jpg',
    details: 'A modern architectural marvel in Doha.',
  },
  {
    src: './Website/Photography/Home/malaysia.jpg',
    details: 'The iconic Petronas Towers in Kuala Lumpur.',
  },
  {
    src: './Website/Photography/Home/bosnia.jpg',
    details: 'A beautiful view of the old bridge in Mostar.',
  },
  {
    src: './Website/Photography/Home/singapore.jpg',
    details: 'Marina Bay Sands and the city skyline.',
  },
  {
    src: './Website/Photography/Home/qatar.jpg',
    details: 'A modern architectural marvel in Doha.',
  },
  {
    src: './Website/Photography/Home/malaysia.jpg',
    details: 'The iconic Petronas Towers in Kuala Lumpur.',
  },
  {
    src: './Website/Photography/Home/bosnia.jpg',
    details: 'A beautiful view of the old bridge in Mostar.',
  },
  {
    src: './Website/Photography/Home/singapore.jpg',
    details: 'Marina Bay Sands and the city skyline.',
  },
  {
    src: './Website/Photography/Home/qatar.jpg',
    details: 'A modern architectural marvel in Doha.',
  },
]
